import { gatewayFetch, GATEWAY_BASE_URL } from './gateway.js';

export async function getServices() {
  const endpoint = '/api/v1/public/catalog/services';

  try {
    const data = await gatewayFetch(endpoint);
    const records = Array.isArray(data) ? data : (data.services || data.list || []);

    return records.map(item => ({
      id: item.id || item.Id,
      name: item.name || item.ServiceName || 'Standard Service',
      category: item.category || item.Category || 'General',
      description: item.description || item.Description || '',
      priceTotal: Number(item.priceTotal || item.StandardPrice || 0),
      baseTimeHours: Number(item.baseTimeHours || item.BaseTimeHours || 1),
      imageUrl: item.imageUrl ? `${GATEWAY_BASE_URL}${item.imageUrl}` : null
    }));
  } catch (error) {
    console.error('Error fetching service catalog:', error);
    return [];
  }
}

export async function getCategories() {
  const services = await getServices();
  const categories = services.map(s => s.category);
  return ['All', ...new Set(categories)];
}